<div>
  <span style="display: inline-block">
                 <mat-chip-list style="display: inline-block">
                        <mat-chip matBadgePosition="below after" matBadgeColor="accent">SPCU</mat-chip>
                    </mat-chip-list>
                    <span class="linkInList">{{edasAlarms.uid}}</span>
            </span>
  <mat-form-field placement="right" [ngbTooltip]="'SEARCH_INPUT_TOOLTIP' | translate">
    <input matInput value="{{filter}}"  (click)="applyFilter()" (keyup)="applyFilter($event.target.value)" [placeholder]="'SEARCH' | translate">
  </mat-form-field>
</div>

<table mat-table [dataSource]="edasAlarmsMatTableDataSource" matSort class="table-striped" style="width:100%"
       matSortActive="type_alarm"
       matSortDirection="desc">


  <ng-container matColumnDef="type_alarm">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'TYPE_ALARM'|translate}}</th>
    <td mat-cell *matCellDef="let alarm">
      <mat-chip-list style="display:inline-block;">
        <mat-chip (click)="applyFilter(alarm.type_alarm)" [style]="getColorType(alarm.type_alarm)">
          <span style="color: white;font-weight: bold">{{alarm.type_alarm}} </span>
        </mat-chip>
      </mat-chip-list>
    </td>
  </ng-container>

  <ng-container matColumnDef="type_trigger">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'TYPE_TRIGGER'|translate}}</th>
    <td mat-cell *matCellDef="let alarm">
      <mat-chip-list style="display:inline-block;">
        <mat-chip [style]="getColorType(alarm.type_trigger)" (click)="applyFilter(alarm.type_trigger)" >
          <span style="color: white;font-weight: bold">{{alarm.type_trigger}} </span>
        </mat-chip>
      </mat-chip-list>
    </td>
  </ng-container>

  <ng-container matColumnDef="type_alert">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'TYPE_ALERT'|translate}}</th>
    <td mat-cell *matCellDef="let alarm">
      <mat-chip-list style="display:inline-block;">
        <mat-chip [style]="getColorType(alarm.type_alert)" (click)="applyFilter(alarm.type_alert)" >
          <span style="color: white;font-weight: bold">{{alarm.type_alert}} </span>
        </mat-chip>
      </mat-chip-list>
    </td>
  </ng-container>

  <ng-container matColumnDef="type_option">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'TYPE_OPTION'|translate}}</th>
    <td mat-cell *matCellDef="let alarm">{{alarm.type_option}}
    </td>
  </ng-container>

  <ng-container matColumnDef="relay">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'RELAY'|translate}}</th>
    <td mat-cell *matCellDef="let alarm">
      <mat-chip-list style="display:inline-block;">
        <mat-chip [style]="getColorType(alarm.relay)" (click)="applyFilter(alarm.relay)" >
          <span style="color: white;font-weight: bold">{{alarm.relay}} </span>
        </mat-chip>
      </mat-chip-list>
    </td>
  </ng-container>

  <ng-container matColumnDef="win_val">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'WIN_VAL'|translate}}</th>
    <td mat-cell *matCellDef="let alarm">{{alarm.win_val}}
    </td>
  </ng-container>

  <ng-container matColumnDef="hysteresis">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'HYSTERESIS'|translate}}</th>
    <td mat-cell *matCellDef="let alarm">{{alarm.hysteresis}}
    </td>
  </ng-container>

  <ng-container matColumnDef="pre_val">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'PRE_VAL'|translate}}</th>
    <td mat-cell *matCellDef="let alarm">{{alarm.pre_val}}
    </td>
  </ng-container>

  <ng-container matColumnDef="post_val">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'POST_VAL'|translate}}</th>
    <td mat-cell *matCellDef="let alarm">{{alarm.post_val}}
    </td>
  </ng-container>

  <ng-container matColumnDef="threshold">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'THRESHOLD'|translate}}</th>
    <td mat-cell *matCellDef="let alarm">{{alarm.threshold}}
    </td>
  </ng-container>

  <ng-container matColumnDef="identifier">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'IDENTIFIER'|translate}}</th>
    <td mat-cell *matCellDef="let alarm" (click)="applyFilter(alarm.identifier)" style="cursor: pointer">{{alarm.identifier}}
    </td>
  </ng-container>

  <ng-container matColumnDef="location_id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LOCATION_ID'|translate}}</th>
    <td mat-cell *matCellDef="let alarm" >{{alarm.location_id}}
    </td>
  </ng-container>

  <ng-container matColumnDef="location_name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LOCATION_NAME'|translate}}</th>
    <td mat-cell *matCellDef="let alarm" (click)="applyFilter(alarm.location_name)" style="cursor: pointer"><b>{{alarm.location_name}}</b>
    </td>
  </ng-container>

  <ng-container matColumnDef="location_length">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LOCATION_LENGTH'|translate}}</th>
    <td mat-cell *matCellDef="let alarm">{{alarm.location_length}} m
    </td>
  </ng-container>

  <ng-container matColumnDef="sensor_uid">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'SENSOR_UID'|translate}}</th>
    <td mat-cell *matCellDef="let alarm">
      <span style="display: inline-block">
                 <mat-chip-list style="display: inline-block">
                        <mat-chip matBadgePosition="below after"
                                  matBadgeColor="accent">
                          <span>{{alarm.identifier.includes('OPT') ? 'Optical' : 'External'}}</span>
                         <span class="inner-badge-length"
                               *ngIf="alarm.identifier.includes('OPT')">{{alarm.location_length}}m</span>


                        </mat-chip>
                    </mat-chip-list>
                    <span class="linkInList" style="cursor: pointer" (click)="applyFilter(alarm.sensor_uid)" >{{alarm.sensor_uid}}</span>
            </span>

    </td>
  </ng-container>

  <ng-container matColumnDef="dau_uid">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'DAU_UID'|translate}}</th>
    <td mat-cell *matCellDef="let alarm">
  <span style="display: inline-block;">
                 <mat-chip-list style="display: inline-block">
                        <mat-chip matBadgePosition="below after" matBadgeColor="accent">DAU</mat-chip>
                    </mat-chip-list>
                    <span class="linkInList" style="cursor: pointer" (click)="applyFilter(alarm.dau_uid)" >{{alarm.dau_uid}}</span>
            </span>
    </td>
  </ng-container>

  <ng-container matColumnDef="spcu_uid">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'spcu_uid'|translate}}</th>
    <td mat-cell *matCellDef="let alarm">{{alarm.spcu_uid}}
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>
